import {
  Component,
  computed,
  inject,
  Input,
  input,
  output,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  HsButtonModule,
  HsIconModule,
  HsTooltipModule,
} from '@hsetu/ngui-components';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HsLayerModule } from '@hsetu/ngui-resources';
import { KfmCardComponent } from '../../card/common/kfm-card.component';
import { ICON_DELETE, ICON_SIGNATURE } from '@shared/ui/icons/icon-constants';
import { Dialog } from '@angular/cdk/dialog';
import { KfmSignatureDialogComponent } from '../signature-dialog/kfm-signature-dialog.component';
import { KfmYesNoDialogComponent } from '../../dialogs/yes-no-dialog/kfm-yes-no-dialog.component';

@Component({
  selector: 'kfm-signature-card',
  imports: [
    CommonModule,
    HsLayerModule,
    HsIconModule,
    KfmCardComponent,
    HsButtonModule,
    HsTooltipModule,
  ],
  templateUrl: './kfm-signature-card.component.html',
})
export class KfmSignatureCardComponent {
  private readonly _sanitizer = inject(DomSanitizer);
  private readonly _dialog = inject(Dialog);

  private _isDialogOpen = false;

  protected readonly tooltipDelete = 'Unterschrift löschen';
  protected readonly tooltipSign = 'Unterschrift hinzufügen/ändern';
  protected readonly iconDelete =
    this._sanitizer.bypassSecurityTrustHtml(ICON_DELETE);

  protected readonly img = signal<string | null>(null);

  protected readonly icon = computed(() => {
    const icon = this.cardIcon();

    if (!icon) {
      return this._sanitizer.bypassSecurityTrustHtml(ICON_SIGNATURE);
    }

    return icon;
  });

  public readonly cardTitle = input<string>('');
  public readonly cardIcon = input<SafeHtml | undefined>(undefined);
  public readonly isEditable = input<boolean>(true);

  @Input()
  public set dataUrl(value: string | null) {
    this.img.set(value);
  }

  public readonly signatureChanged = output<string | null>();

  protected onSignClicked() {
    if (this._isDialogOpen) {
      return;
    }

    this._isDialogOpen = true;

    const dialogRef = this._dialog.open<string | null>(
      KfmSignatureDialogComponent,
      {
        width: '600px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        data: {
          imgDataUrl: this.img(),
        },
      },
    );

    dialogRef.closed.subscribe(async (result) => {
      if (result) {
        this.img.set(result);
        this.signatureChanged.emit(result);
      }

      this._isDialogOpen = false;
    });
  }

  protected onDeleteClicked() {
    if (this._isDialogOpen) {
      return;
    }

    this._isDialogOpen = true;

    const dialogRef = this._dialog.open<string | null>(
      KfmYesNoDialogComponent,
      {
        width: '600px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        data: {
          title: 'Unterschrift löschen',
          text: 'Möchten Sie die Unterschrift wirklich löschen?',
        },
      },
    );

    dialogRef.closed.subscribe(async (result) => {
      if (result) {
        this.img.set(null);
        this.signatureChanged.emit(null);
      }

      this._isDialogOpen = false;
    });
  }
}
